import { Element } from "@siteimprove/alfa-dom";
import { hasComputedStyle } from "./has-computed-style.js";
import { Longhands } from "../../longhands.js";
/**
 * @public
 */
export function hasInitialComputedStyle(name, device, context) {
    return hasComputedStyle(name, (value) => value.equals(Longhands.get(name).initial), device, context);
}
//# sourceMappingURL=has-initial-computed-style.js.map